import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject =
    new BehaviorSubject<boolean>(false);

  loading$ = this.loadingSubject.asObservable();

  // Émission différée (microtask) : évite de muter l'état pendant un cycle de
  // détection de changement déclenché par l'intercepteur HTTP, source de
  // NG0100 ExpressionChangedAfterItHasBeenCheckedError.
  loadingOn() {
    queueMicrotask(() => this.loadingSubject.next(true));
  }

  loadingOff() {
    queueMicrotask(() => this.loadingSubject.next(false));
  }
}
